import { useEffect } from "react";

export function useJsonLd(id: string, data: Record<string, any>) {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }

    el.text = JSON.stringify(data);

    return () => {
      // evita acumular scripts ao navegar
      const current = document.getElementById(scriptId);
      if (current) current.remove();
    };
  }, [id, data]);
}
